import React from "react"
import routes from "@love-irish/routes"
import { IconClover2, IconHeart } from "@tabler/icons-react"
import Badge from "design_system/core/components/badge"
import whiteHoodieImage from "images/ecommerce/products/obair-white-hoodie.png"
import redHoodieImage from "images/ecommerce/products/cali-sun-black-hoodie.png"

const communicationFeatures = [
  {
    id: 1,
    name: "Modern designs",
    description:
      "Find premium Celtic apparel beyond the usual 'Kiss me I'm Irish' designs so you can wear your pride with style.",
    icon: IconHeart,
  },
  {
    id: 2,
    name: "Supporting Celtic brands & artists",
    description:
      "Our mission is to support being making a living off their craft while contributing to the Celtic language revival.",
    icon: IconClover2,
  },
]

const ShopSection = () => {
  return (
    <div className="relative">
      <div className="lg:grid lg:grid-flow-row-dense lg:grid-cols-2 lg:items-start lg:gap-20">
        <div className="lg:col-start-2">
          <Badge className="mb-4">New</Badge>
          <a href={routes.shopPath()} target="_blank">
            <h3 className="text-2xl font-normal tracking-tight text-gray-900 sm:text-3xl font-serif">
              Ár Siopa{" "}
              <span className="text-gray-400 text-base font-sans">
                &ldquo;Our Shop&rdquo;
              </span>
            </h3>
          </a>
          <p className="mt-3 text-lg text-gray-500">
            Handpicked goods &amp; gifts featuring Celtic languages, artists,
            goods & more from around the world
          </p>

          <dl className="mt-10 space-y-10">
            {communicationFeatures.map((item) => (
              <div key={item.id} className="relative">
                <dt>
                  <div className="absolute flex h-12 w-12 items-center justify-center rounded-xl bg-secondary-100 text-secondary-500">
                    <item.icon className="h-8 w-8" aria-hidden="true" />
                  </div>
                  <p className="ml-16 text-lg font-medium leading-6 text-gray-900">
                    {item.name}
                  </p>
                </dt>
                <dd className="mt-2 ml-16 text-base text-gray-500">
                  {item.description}
                </dd>
              </div>
            ))}
          </dl>
        </div>
        <div className="relative -mx-4 mt-10 lg:mt-0 hidden lg:block">
          <div className="relative mx-auto ">
            <a href="https://shop.love.irish/collections/mens-tank-tops/products/obair-work-sly-grug-embroidered-mens-hoodie">
              <img
                className="absolute rotate-12 right-0 top-1/2 -translate-y-8 p-8"
                src={whiteHoodieImage}
                width="400"
                alt="'Golbin Mode' Mens Muscle Tank Top"
              />
            </a>
            <a href="https://shop.love.irish/collections/mens-hoodies/products/cali-sun-embroidered-mens-hoodie">
              <img
                className="absolute -rotate-12 left-0 top-1/2 -translate-y-8 -translate-x-1/4"
                src={redHoodieImage}
                width="400"
                alt="Cali Sun Embroidered Black Hoodie"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

ShopSection.propTypes = {}

export default ShopSection
